import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { AlertController, LoadingController, ModalController, NavController, NavParams, Platform, ToastController } from '@ionic/angular';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { ClubData, ClubInfo, ClubMembershipExtended, ClubMembershipOption, ClubMembershipType, CountryData, PaymentGatewayInfo, PlayerClubStat, PlayerInfo, PlayerClubAccount } from 'src/data/mygolf.data';
import { adjustViewZIndex, getDistanceInKM } from 'src/globals';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { ClubService } from 'src/providers/club-service/club-service';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';
import { PaymentService } from 'src/providers/payment-service/payment-service';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { resolve } from 'url';
import { sha256 } from 'js-sha256';

@Component({
  selector: 'app-player-pay-club-membership',
  templateUrl: './player-pay-club-membership.page.html',
  styleUrls: ['./player-pay-club-membership.page.scss'],
})
export class PlayerPayClubMembershipPage implements OnInit {

  public refresher: any;
  public infinite: any;
  public searchQuery: string = "";

  public recentClubs: Array<ClubInfo>;
  public nearByClubs: Array<ClubInfo>;

  clubInfo: ClubData;
  player$: Observable<PlayerInfo>;

  clubMembershipTypes: Array<ClubMembershipType>;

  selMembershipType: ClubMembershipType = null;
  // {
  //     typeId: 'FULL'
  // };

  clubMembershipOption: ClubMembershipOption;
  enableStatementEmail: boolean = false;
  correspondenceEmail: string;
  setHomeClub: boolean = false;
  joinedOn: string;
  validUntil: string;
  editMode: boolean = false;
  clubMembership: ClubMembershipExtended;
  membershipNo: string;

  modalMode: boolean = true;
  fromClub: boolean = false;
  selectedMembershipType: string = 'FULL';
  maxDate: string;

  paymentAmount: number = 0;
  outstandingAmount: number = 0;
  selectedPaymentAmount: string = 'outstandingAmount';
  accountDetails: PlayerClubAccount; // PlayerClubStat;
  currencyCode: string = '$';
  currencySymbol: string = '$';
  clubCountry: CountryData;
  selectPaymentMethod: string = 'billplz';
  // iab: any;

  options: InAppBrowserOptions = {
    location: 'yes', //Or 'no'
    hidden: 'no', //Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes', //Android only ,shows browser zoom controls
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', //Android only
    closebuttoncaption: 'Close', //iOS only
    disallowoverscroll: 'no', //iOS only
    toolbar: 'yes', //iOS only
    enableViewportScale: 'no', //iOS only
    allowInlineMediaPlayback: 'no', //iOS only
    presentationstyle: 'pagesheet', //iOS only
    fullscreen: 'yes', //Windows only
};

sandboxPayment: boolean = false;
  constructor(
    private nav: NavController,
    private renderer: Renderer2,
    private alertCtl: AlertController,
    private geo: GeolocationService,
    private clubService: ClubService,
    private loadingCtl: LoadingController,
    private flightService: ClubFlightService,
    private navParams: NavParams,
    private platform: Platform,
    private toastCtl: ToastController,
    private paymentService: PaymentService,
    private mg2uUtil: mygolfUtils,
    private modalCtl: ModalController,
    private router: Router,
    private iab: InAppBrowser
  ) {
    this.recentClubs = new Array<ClubInfo>();
    this.nearByClubs = new Array<ClubInfo>();

    if (this.router.getCurrentNavigation()) {
      this.player$ = this.router.getCurrentNavigation().extras.state.player;
      this.clubInfo = this.router.getCurrentNavigation().extras.state.clubInfo;
      this.editMode = this.router.getCurrentNavigation().extras.state.editMode;
      this.clubMembership = this.router.getCurrentNavigation().extras.state.clubMembership;
      this.fromClub = this.router.getCurrentNavigation().extras.state.fromClub;

      this.accountDetails = this.router.getCurrentNavigation().extras.state.accountDetails;
      if(this.accountDetails && this.accountDetails.effectiveBalance != 0) {
          this.outstandingAmount = this.accountDetails.effectiveBalance<0?-1*this.accountDetails.effectiveBalance:0;
          this.paymentAmount = this.outstandingAmount;
      }
    }
    else {
      this.player$ = navParams.get('player');
      this.clubInfo = navParams.get('clubInfo');
      this.editMode = navParams.get('editMode');
      this.clubMembership = navParams.get('clubMembership');
      this.fromClub = navParams.get('fromClub');
      this.accountDetails = navParams.get('accountDetails');
    }


    if (this.accountDetails && this.accountDetails.effectiveBalance != 0) {
      this.outstandingAmount = this.accountDetails.effectiveBalance < 0 ? -1 * this.accountDetails.effectiveBalance : 0;
      this.paymentAmount = this.outstandingAmount;
    }

    if (this.clubInfo && this.clubInfo.address && this.clubInfo.address.countryData) {
      this.currencyCode = this.clubInfo.address.countryData.currencyCode;
      this.currencySymbol = this.clubInfo.address.countryData.currencySymbol;
      this.clubCountry = this.clubInfo.address.countryData;
    }


    this.validUntil = moment().format("YYYY-MM-DD");
    this.joinedOn = moment().format("YYYY-MM-DD");

    this.maxDate = moment().add(30, 'y').format("YYYY-MM-DD");
  }

  ngOnInit() {
    let _countryId = this.clubCountry?.id || this.clubInfo?.country?.id;
    this.getPaymentGateway(_countryId);
  }

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  onSearchInput(searchbar) {
    this._refreshValues();
  }


  /**
   * Gets the distance between a current location and club in KMs
   * @param club The club information
   * @returns {number} Returns the distance in KM if GPS locations of current and club are available
   * else returns 0;
   */
  clubDistance(club: ClubInfo): string {
    let lat1 = this.geo.getLatitude();
    let lon1 = this.geo.getLongitude();
    if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null)
      return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + " KM";
    return "";
  }

  /**
   * Executed when refresh button on toolbar is clicked
   */
  onRefreshClick(refresher) {
    this.refresher = refresher;
    this._refreshValues();
  }

  clubSelected(event, item: ClubInfo) {
    //  this.events.publish("clubSelected", item);
    this.clubMembershipNumberPrompt();
  }

  private async _refreshValues() {
    let loader = await this.loadingCtl.create({});

    loader.present().then(() => {
      this.clubService.getRecentClubs(0)
        .subscribe((recentClubs: Array<ClubInfo>) => {

          this.clubService.getNearbyClubs(3000)
            .subscribe((nearbyClubs: Array<ClubInfo>) => {
              loader.dismiss().then(() => {
                this.recentClubs = recentClubs;
                this.nearByClubs = nearbyClubs;
              })
            }, (error) => {
              loader.dismiss();
              console.log(error);
            }, () => {
              if (this.refresher) {
                this.refresher.complete();
                this.refresher = null;
              }
            });
        }, (error) => {
          loader.dismiss();
          console.log(error);
        }, () => {
          if (this.refresher) {
            this.refresher.complete();
            this.refresher = null;
          }
        });
    })

  }

  async clubMembershipNumberPrompt() {
    let prompt = await this.alertCtl.create({
      header: 'Club Membership',
      message: "Enter your club Membership Number",
      inputs: [
        {
          name: 'membershipNumber',
          placeholder: 'Membership Number'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Save',
          handler: data => {
            this.nav.pop();
          }
        }
      ]
    });
    prompt.present();
  }

  getPlayerDetails(attribute?: string) {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    switch (attribute) {
      case 'name':
        return _player.playerName
    }

  }

  getClubDetails(attribute?: string) {
    let _clubInfo: ClubData; //ClubInfo;
    let _clubName;
    if (!this.editMode) _clubInfo = this.clubInfo;
    else if (this.editMode) _clubName = this.clubMembership.club.name;


    switch (attribute) {
      case 'name':
        if (this.editMode) return _clubName;
        else return _clubInfo.clubName;
    }
  }

  getListClubMembershipTypes(clubId: number) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    this.flightService.getListClubMembershipTypes(_params)
      .subscribe((data: Array<ClubMembershipType>) => {
        if (data && data.length > 0) {
          console.debug("club membership types : ", data)
          this.clubMembershipTypes = data;

          // this.selMembershipType =
          this.clubMembershipTypes.filter((type: ClubMembershipType) => {
            return type.typeId === 'FULL'
          }).map((type: ClubMembershipType) => {
            // this.selMembershipType = JSON.parse(JSON.stringify(type));
            this.selectedMembershipType = type.typeId;
          });
        } else if (!this.editMode) {
          if (!this.clubMembershipTypes) this.clubMembershipTypes = [];
          this.clubMembershipTypes.push({
            typeId: 'FULL',
            typeName: 'Full Membership'
          });
          // this.selMembershipType = JSON.parse(JSON.stringify(this.clubMembershipTypes[0]));
          this.selectedMembershipType = this.clubMembershipTypes[0].typeId;

          this.clubMembershipTypes.filter((type: ClubMembershipType) => {
            return type.typeId === 'FULL'
          }).map((type: ClubMembershipType) => {
            // this.selMembershipType = JSON.parse(JSON.stringify(type));
            this.selectedMembershipType = type.typeId;
          });

          let _msg = 'This club currently have no Club Membership Types defined'
          MessageDisplayUtil.showMessageToast(_msg,
            this.platform, this.toastCtl, 3000, "bottom")

          this.modalCtl.dismiss();
          return false;
        }
        if (this.editMode && this.clubMembership) {
          // this.selMembershipType = JSON.parse(JSON.stringify(this.clubMembership.membershipType));
          this.selectedMembershipType = this.clubMembership.membershipType.typeId;
        }
      }, (error) => {
        let _msg = 'This club currently have no Club Membership Types defined'
        MessageDisplayUtil.showMessageToast(_msg,
          this.platform, this.toastCtl, 3000, "bottom")
        return false;
      })
  }

  getClubMembershipOptions(clubId: number) {
    let _clubId = clubId;
    this.flightService.getClubMembershipOptions(_clubId)
      .subscribe((data: ClubMembershipOption) => {
        if (data) {
          console.debug("club membership types : ", data)
          this.clubMembershipOption = data;
        }
      })
  }

  onSaveClubMembership() {
    if (!this.membershipNo || this.membershipNo.length === 0) {
      MessageDisplayUtil.showMessageToast('Please specify Membership Number',
        this.platform, this.toastCtl, 3000, "bottom")
      return false;
    }
    // if(!this.selMembershipType) {
    if (!this.selectedMembershipType) {
      MessageDisplayUtil.showMessageToast('Please specify the membership type',
        this.platform, this.toastCtl, 3000, "bottom")
      return false;
    }
    let _joinedOn = moment(this.joinedOn, "YYYY-MM-DD").toDate();
    let _validUntil = moment(this.validUntil, "YYYY-MM-DD").toDate();
    if (this.selectedMembershipType.toLowerCase() !== 'full' && (_joinedOn >= _validUntil)) {
      console.debug("save club membership : ", this.selectedMembershipType, _joinedOn, _validUntil)
      MessageDisplayUtil.showMessageToast('Please specify valid dates for Joined On and Valid Until',
        this.platform, this.toastCtl, 3000, "bottom")
      return false;
    }
    if (this.enableStatementEmail && (this.correspondenceEmail && this.correspondenceEmail.length === 0 || !this.correspondenceEmail)) {
      MessageDisplayUtil.showMessageToast('Please specify the email address',
        this.platform, this.toastCtl, 3000, "bottom")
      return false;
    }
    this.goSaveClubMembership();
  }
  goSaveClubMembership() {
    let _clubId;
    if (this.editMode) {
      _clubId = this.clubMembership.club.id;
    } else {
      _clubId = this.clubInfo.clubId;
    }
    let _player: PlayerInfo;
    let _playerId;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
      _playerId = player.playerId ? player.playerId : player.id;
    });

    if (this.selectedMembershipType === 'FULL')
      this.validUntil = '2999-12-31'
    let _params;
    _params = {
      membershipNo: this.membershipNo,
      membershipType: this.selectedMembershipType,
      joinedOn: this.joinedOn,
      validUntil: this.validUntil,
      statementEmail: this.enableStatementEmail,
      correspondenceEmail: this.correspondenceEmail,
      homeClub: this.setHomeClub
    }
    this.flightService.createUpdatePrimaryMembership(_clubId, _playerId, _params)
      .subscribe((clubMembership: ClubMembershipExtended) => {
        if (clubMembership) {
          console.debug("save club membership : ", clubMembership)
          if (!this.fromClub)
            MessageDisplayUtil.showMessageToast('Successfully added club as membership. Please contact club for approval.',
              this.platform, this.toastCtl, 3000, "bottom")

          this.modalCtl.dismiss(clubMembership);
          return false;
        }
      }, async (error) => {


        let _error = error.json();
        let _title = 'Add Membership Failed';
        let _msg = _error.errorMessage;

        let prompt = await this.alertCtl.create({
          header: _title,
          cssClass: 'booking-error',
          message: _msg,
          buttons: [
            {
              text: 'Ok',
              handler: data => {
              }
            },
          ]
        });
        prompt.present();

        // MessageDisplayUtil.showMessageToast(_msg,
        // this.platform, this.toastCtl, 3000, "bottom")
        return false;
      })
  }

  onClose() {
    this.modalCtl.dismiss();
  }

  onChangeMembershipType() {
    console.debug("on change membership type ", this.selMembershipType, this.selectedMembershipType,);
    // if(!this.selMembershipType) return;
    // let _selectedType;
    this.clubMembershipTypes.filter((type) => {
      return type.typeId === this.selectedMembershipType;
    }).map((type) => {
      this.selMembershipType = type;
      if (!this.selMembershipType.termMembership) {
        this.validUntil = '2999-12-31'
      } else if (this.selMembershipType.termMembership) {
        this.validUntil = moment().add(1, 'y').format("YYYY-MM-DD")
      }
    })
  }

  cancelPayment() {

    this.modalCtl.dismiss({
      needRefresh: true
    })
  }

  paymentGatewayList: Array<PaymentGatewayInfo>;
  getPaymentGateway(countryId?: string, paymentGatewayId?: string) {
    let _paymentGateway;
    let _countryId = countryId ? countryId : null;
    this.paymentService.getPaymentGateway(_countryId, _paymentGateway)
      .subscribe((pgList: Array<PaymentGatewayInfo>) => {
        //  console.debug("client payment gateway ", pgList)
        if (pgList && pgList.length > 0) {
          this.paymentGatewayList = pgList.filter((pg: PaymentGatewayInfo) => {
            return this.clubCountry && pg.country_id === this.clubCountry.id
          })
        }
      })
  }

  onVerifyPay() {
    return new Promise((resolve, reject) => {
      if (this.selectPaymentMethod === null || !this.selectPaymentMethod) {
        reject({
          status: 'error',
          message: 'Please select a payment method'
        })
      }
      if (this.paymentAmount === null || this.paymentAmount <= 0) {
        reject({
          status: 'error',
          message: 'Please specify valid payment amount'
        })
      }
      if (this.selectPaymentMethod !== 'testDev' && this.selectPaymentMethod !== 'billplz'
      && this.selectPaymentMethod !== 'ipay88-my-sb' && this.selectPaymentMethod !== 'ipay88-my') {
        reject({
          status: 'error',
          message: 'Other payment than Direct & BillPlz are not supported yet'
        })
      }
      resolve({
        status: 'success',
        message: 'Can pay'
      })
    })
  }
  onClickPayNow() {
    this.onVerifyPay()
      .then((result: any) => {
        if (result && result.status === 'success') {
          this.goPayMembership();
        }
      }).catch((error: any) => {
        let _msg = '';
        if (error && error.message) _msg = error.message;
        MessageDisplayUtil.showMessageToast(_msg,
          this.platform, this.toastCtl, 3000, "bottom")
        return;
      })
  }

  numericOnly(event) {
    console.debug('numeric only : ', event)
  }

  getPaymentAmount() {
    console.debug("get payment amount : ", this.paymentAmount, this.outstandingAmount)
    if (!this.paymentAmount || this.paymentAmount === null) return;
    if (this.paymentAmount === undefined) return;
    if (this.paymentAmount && this.paymentAmount < 0) return;
    return this.mg2uUtil.numberWithCommas(Number(this.paymentAmount).toFixed(2));
  }

  // goPayMembership() {
  //   let _clubId = this.clubInfo.id || this.clubInfo.id;
  //   let _playerId = this.clubMembership.player.id || this.clubMembership.player.playerId
  //   let _currentDate = moment().format("YYYY-MM-DD");
  //   let _currency = this.currencySymbol;
  //   let _amount = this.paymentAmount;
  //   let _params = {
  //     paidOn: _currentDate,
  //     reference: 'Payment of ' + _currency + ' ' + _amount + ' on ' + moment(_currentDate, 'YYYY-MM-DD').format("DD MMM YYYY"),
  //     amount: _amount,
  //   }
  //   console.debug("go pay membership", this.clubInfo, this.clubMembership, _currency, _amount, _params)
  //   this.flightService.makeClubPayment(_clubId, _playerId, _params)
  //     .subscribe((data) => {
  //       if (data) {
  //         MessageDisplayUtil.showMessageToast('Successfully made payment',
  //           this.platform, this.toastCtl, 3000, "bottom")
  //         this.modalCtl.dismiss();
  //       }
  //     })
  // }

  paymentRedirectURL: string;
  ipay88Details: any;
  paymentBackendURL: string; //;
  paymentInternalURL: string; //;
  paymentPageURL: string; //
  paymentSignAlgo: string;
  _url: string;
  goPayMembership(directAPI: boolean = false) {
      let _clubId = this.clubInfo.id || this.clubInfo.id;
      let _playerId = this.clubMembership.player.id || this.clubMembership.player.playerId
      let _currentDate = moment().format("YYYY-MM-DD");
      let _currency = this.currencySymbol;
      let _amount = this.paymentAmount;
      let _params = {
          paidOn: _currentDate,
          reference: 'Payment of '+_currency+' '+_amount+ ' on '+ moment(_currentDate,'YYYY-MM-DD').format("DD MMM YYYY"),
          amount: _amount,
      }

      let _description;
      if(this.selectPaymentMethod === 'testDev' || directAPI) {
          this.flightService.makeClubPayment(_clubId, _playerId, _params)
          .subscribe((data)=>{
              if(data) {
                  MessageDisplayUtil.showMessageToast('Successfully made payment',
                      this.platform, this.toastCtl, 3000, "bottom")
                  this.modalCtl.dismiss({
                      success: true
                  });
              } else {
                  if(this.enablePaymentTimer) {
                      this.paymentFailed = true;
                      this.paymentDateTime = moment();
                  }
              }
          },(error)=>{
              if(this.enablePaymentTimer) {
                  this.paymentFailed = true;
                  this.paymentDateTime = moment();
              }
          })
      } else {
        let _pgRegion;
          this.paymentGatewayList.filter((pg)=>{
              return pg.id === this.selectPaymentMethod
          }).map((pg)=>{
              this.paymentRedirectURL = pg.redirect_url;
              this.ipay88Details = pg;
              this.ipay88Details.merchantCode = pg.merchant_code;
              _description = pg.description;
              this.paymentBackendURL = pg.callback_url;
              this.paymentRedirectURL = pg.redirect_url;
              this.paymentInternalURL = pg.internal_payment_url;
              this.paymentPageURL = pg.http_server + pg.payment_url;
              if(pg.signature_algorithm && pg.signature_algorithm.length > 0) this.paymentSignAlgo = pg.signature_algorithm;
              if (pg.signature_algorithm && pg.signature_algorithm.length > 0 && (pg.signature_algorithm.toLowerCase() === 'sha-256' || pg.signature_algorithm.toLowerCase() === 'sha-1'))
              this.paymentSignAlgo = this.paymentSignAlgo.replace('-','');
              this._url = this.paymentInternalURL?this.paymentInternalURL:pg.internal_payment_url;
              _pgRegion = pg.id;

          })
          let loading = this.loadingCtl.create({
              showBackdrop: false,
              cssClass    : "nobg",
              message    : "Signing up..."
          });


          let _paymentDetails = {
              "collection_id": 'q70lo0l_',
              "amount": this.paymentAmount*100,
              "email": this.clubMembership.player.email,
              "name": this.clubMembership.player.playerName,
              "mobile": this.clubMembership.player.phone,
              "description": 'Payment for Club Statement',
              "currency": this.clubCountry?.currencyCode,
              "callback_url": '', //this.paymentCallbackURL,// 'http://devlet.mygolf2u.com/rest/payment/billplz/callback',
              // "redirect_url": this.paymentRedirectURL, //'http://mtest.mygolf2u.com/test/payment_redirect.html',
              "bill_type": 'club_membership',
              "bill_type_id": this.clubMembership.id, //application ID
              "paid_by": _playerId,//if Player, playerId; if partner/club, userId?  this.fromClub?this.currSession.userId:this.currentPlayerId,
              "payer_type": 'R', //if Player, 'R'; if partner/club, 'C'?
              "payment_type": 'B', //this is Full Payment?
              "payment_gateway": this.selectPaymentMethod, // 'billplz',
          }
          let _paymentGateway = this.selectPaymentMethod; // 'billplz';
          let _countryId = this.clubCountry?.id; // this.clubMembership?.club?.country?.id; // 'MYS';

          this.onProcessPayment(_paymentDetails, _paymentGateway, _pgRegion, _countryId, _description);
          // this.getPaymentGatewayPromise()
          // .then((result: any)=>{
          //     if(result && result.status === 'success') {
          //         this.onContinueApplication(value,loading);
          //     }
          // }).catch((error)=>{

          // })
      }
  }


  enablePaymentTimer: boolean = false;
  paymentFailed: boolean = false;
  paymentDateTime: any;
  paymentTimerDuration: number = 5; //in minutes
  async blockPayment() {
  // this.enablePaymentTimer = true;
  console.debug("payment check - ", this.enablePaymentTimer, this.paymentFailed, this.paymentDateTime)
  let _block: boolean = false;
  if(this.enablePaymentTimer) {
      if(this.paymentFailed && this.paymentDateTime) {
          let _currTime = moment();
          let _diffMinutes = _currTime.diff(this.paymentDateTime, 'minutes')
          console.debug("payment check - ", _currTime, _diffMinutes, this.paymentDateTime)
          if(_diffMinutes >= 0 && _diffMinutes < this.paymentTimerDuration ) {

            this.showMessage('Payment not successful', 'Your previous payment was not successful or in pending, please try again after ' + (this.paymentTimerDuration - _diffMinutes) + ' minute(s)', true)
            .then((result: any)=>{
              if(result) {
                this.modalCtl.dismiss({
                  needRefresh: true,
                  paymentDateTime: this.paymentDateTime,
                  paymentStatus: 'failed'
                });
              }
            });
              // let alert = await this.alertCtl.create({
              //   subHeader: 'Payment',
              //   // subTitle: 'Selected date is '+ _date,
              //   message: 'Your previous payment was not successful or in pending, please try again after ' + (this.paymentTimerDuration - _diffMinutes) + ' minute(s)', //'Selected date is ' + '<b>' + _date + '</b>',
              //   buttons: [{
              //     text: 'OK',
              //     handler: () => {
              //       // this.onRefreshClick();
              //       this.modalCtl.dismiss({
              //         needRefresh: true,
              //         paymentDateTime: this.paymentDateTime,
              //         paymentStatus: 'failed'
              //       });
              //     }
              //   }],
              // });
              // alert.present();
              _block = true;

          }
      }
  }
  return _block
}

  async onProcessPayment(paymentDetails,_paymentGateway,_pgRegion?, _countryId?,_pgDescription?) {
  console.debug("on process payment : ", paymentDetails,_paymentGateway,_pgRegion, _countryId,_pgDescription)
  let _collectionId: string = 'q70lo0l_';
  let _signature = '';
  let loader = this.loadingCtl.create({
      showBackdrop: false,
      cssClass    : "nobg",
      message    : "Processing payment...",
      duration    : 10000
  });
  (await loader).present().then(() => {
      this.paymentService.createBill(_collectionId, paymentDetails, _paymentGateway)
          .subscribe(async (data: any) => {
              (await loader).dismiss().then(() => {
                  if (data.url && this.selectPaymentMethod.toLowerCase().includes('billplz')) {
                  // (data.url && this.selectPaymentMethod !== 'ipay88' && this.selectPaymentMethod !== 'ipay88page'
                  // && this.selectPaymentMethod !== 'ipay88fpx') {
                      if (this.platform.is('cordova')) {
                          this.openWithInAppBrowser(data.url,null,'getBill',data)
                      }
                      else {
                        //  console.debug("create bill payment page ", data, " - ", this.platform)
                          // this.openWithCordovaBrowser(data.url);
                          let win = window.open(data.url, '_system');

                          let winTick = setInterval(()=> {
                              if (win && win.closed) {
                                  clearInterval(winTick);
                                  this.getBill(data.id, 'billplz');
                                //  console.debug('window closed!');
                              }
                          }, 500);


                      }

                  }
                    else if (data && (this.selectPaymentMethod.toLowerCase().includes('ipay88'))) {
                        // this.selectPaymentMethod === 'ipay88page' || this.selectPaymentMethod === 'ipay88fpx'

                       console.debug("for ipay88page ", data, this.selectPaymentMethod)

                        let _data = data;
                        let _type = _paymentGateway;

                        let _amountPay;
                        let _amount;
                        if(paymentDetails && paymentDetails.amount) _amountPay = paymentDetails.amount;
                        // if(paymentDetails && paymentDetails.amount) _amount = paymentDetails.amount;
                        //  = (_pgRegion.toLowerCase().includes('ipay88-id'))?_amountPay*100:1.00;
                        if(_pgRegion?.toLowerCase().includes('ipay88-id') && _countryId.toLowerCase()==='idn' && _pgDescription.toLowerCase('sandbox')) {
                          this.sandboxPayment = true;
                          _amountPay = 10000;
                        }
                        else if(_pgRegion?.toLowerCase().includes('ipay88-id') && _countryId.toLowerCase()==='idn' && _pgDescription.toLowerCase('sandbox')) {
                          this.sandboxPayment = true;
                          _amount = _amountPay*100
                        }
                        // else if(!_pgRegion.toLowerCase().includes('ipay88-id') && this.pgDescription.toLowerCase().includes('Sandbox'.toLowerCase())) _amount = 1*100;
                        else if(_type.toLowerCase().includes('ipay88') && _countryId.toLowerCase()==='mys' && !_pgDescription.toLowerCase().includes('Sandbox'.toLowerCase()))
                            _amount = _amountPay.toFixed(2);
                        else if(_type.toLowerCase().includes('ipay88') && _countryId.toLowerCase()==='mys' && _pgDescription.toLowerCase().includes('Sandbox'.toLowerCase()))
                            _amount = 100;
                        else _amount = _amountPay*100;

                        let _ipayUrl;
                        if(this.selectPaymentMethod === 'ipay88fpx') _ipayUrl = 'https://dvl3.ipay88.com/epayment/entry.asp';
                        else {
                            // if(_pgRegion.toLowerCase().includes('ipay88-id'))
                            // _ipayUrl = this.paymentPageURL; //'https://sandbox.ipay88.co.id/epayment/entry.asp';
                            // else _ipayUrl = 'https://payment.ipay88.com.my/epayment/entry.asp';
                        }
                        // this.localBill = _data.bill;

                        let paymentDetailsPage;
                        let _currency = this.clubCountry.currencyCode;
                        if(0 && this.selectPaymentMethod==='ipay88fpx') {
                        } else {
                            // _signature = 'huqhrKBj1i' + 'M27515' + _data.bill + _amount + this.bookingSlot.slotAssigned.currency.id;
                            if(_pgRegion?.toLowerCase().includes('ipay88-id')  && _pgDescription?.toLowerCase().includes('sandbox'))
                                _signature = this.ipay88Details.merchantKey + this.ipay88Details.merchantCode + _data.bill + Number(_amount).toFixed(0) + _currency;
                            else if(_pgRegion?.toLowerCase().includes('ipay88-id')  && !_pgDescription.toLowerCase().includes('sandbox'))
                                _signature = this.ipay88Details.merchantKey + this.ipay88Details.merchantCode + _data.bill + Number(_amountPay).toFixed(0) + _currency;
                            else if(_pgRegion?.toLowerCase() === 'ipay88' && _pgDescription?.toLowerCase().includes('sandbox'))
                                _signature = this.ipay88Details.merchantKey + this.ipay88Details.merchantCode + _data.bill + Number(100).toFixed(0) + _currency;
                            else if(_pgRegion?.toLowerCase().includes('ipay88-my') && _pgDescription?.toLowerCase().includes('sandbox'))
                                _signature = this.ipay88Details.merchantKey + this.ipay88Details.merchantCode + _data.bill + Number(1).toFixed(0) + _currency;
                            else _signature = this.ipay88Details.merchantKey + this.ipay88Details.merchantCode + _data.bill + Number(_amountPay).toFixed(0) + _currency;
                            // *100

                        // _signature = 'huqhrKBj1i'+'M27515'+'TestPay88_'+moment().format('HHmmss')+'1'+this.bookingSlot.slotAssigned.currency.id;
                        console.debug("ipay88 signature : ", this.ipay88Details, _pgRegion)
                       console.debug("ipay88 signature", _signature)
                        // console.debug("ipay88 signature test huqhrKBj1iM27515472100MYR ", sha256('huqhrKBj1iM27515472100MYR'));
                        // console.debug("ipay88 signature test huqhrKBj1iM275154721MYR ", sha256('huqhrKBj1iM275154721MYR'));
                       console.debug("ipay88 signature 256", sha256(_signature));
                    //!    console.debug("ipay88 signature 1", this.sha1.iPay88Signature(_signature));
                      //  console.debug("ipay88 signature server", data.signature);
                       console.debug("ipay88 signature pg region", _pgRegion);
                    //    console.debug("ipay88 signature - sandbox payment ", this.sandboxPayment)
                      //  console.debug("ipay88 signature signature type", this.paymentSignAlgo);

                      //  console.debug("[1] payment details : ", _amount, _amountPay)
                      let sha256_signature = this.mg2uUtil.generateHashSignature(this.paymentSignAlgo, _signature, this.ipay88Details.merchantKey); //sha256(_signature);
                      let sha1_signature = this.mg2uUtil.generateHashSignature('sha1', _signature); //this.sha1.iPay88Signature(_signature);
                          let ipay88_signature;
                        // if(data && data.signature) ipay88_signature = (_pgRegion.toLowerCase().includes('ipay88-id'))?data.signature:sha256_signature; //data.signature;
                        // else ipay88_signature = (_pgRegion.toLowerCase().includes('ipay88-id'))?sha1_signature:sha256_signature;
                        ipay88_signature = (_pgRegion.toLowerCase().includes('ipay88-id'))?sha1_signature:sha256_signature;
                        // ipay88_signature = (_pgRegion==='ipay88-id')?sha1_signature:sha256_signature
                      //  console.debug("create bill data : ", data);
                      //  console.debug("ipay88signature ", ipay88_signature, this.paymentSignAlgo, this.ipay88Details)
                        let _userEmail = 'email@abc.com'; // this.player.email;
                        let _userName = 'player name'; //this.player.playerName
                        let _userContact = '0123456789'; //this.player.phone;


                        console.debug("ipay 88", this.ipay88Details, _pgRegion, _amount, _amountPay)
                        console.debug("ipay 88", ipay88_signature, _signature)
                        let _finalAmount = this.sandboxPayment?1:((_amountPay/100)).toFixed(2)
                            paymentDetailsPage = {
                                "MerchantCode": this.ipay88Details.merchantCode,
                                "PaymentId": '',
                                "RefNo": _data.bill, //'TestPay88_'+moment().format('HHmmss'),
                                "Amount": _finalAmount,
                                "Currency": _currency,
                                "ProdDesc": "NHS Handicap Application",
                                "UserEmail": _userEmail,
                                "UserName": _userName,
                                "UserContact": _userContact,
                                // "UserName": this.bookingSlot.bookedByPlayer?this.bookingSlot.bookedByPlayer.playerName:this.bookingSlot.bookingPlayers[0].playerName ,
                                // "UserEmail": this.bookingSlot.bookedByPlayer?this.bookingSlot.bookedByPlayer.email:this.bookingSlot.bookingPlayers[0].email,
                                // "UserContact": this.bookingSlot.bookedByPlayer?(this.bookingSlot.bookedByPlayer.address.phone1 ? this.bookingSlot.bookedByPlayer.address.phone1: this.bookingSlot.bookedByPlayer.address.phone2):this.bookingSlot.bookingPlayers[0].phone, //this.bookingSlot., no phone in bookedbyplayer!
                                "Remark": "Payment for NHS Subscription",
                                "SignatureType": this.paymentSignAlgo.toUpperCase(),
                                // _pgRegion==='ipay88-id'?'SHA1':'SHA256',
                                "Signature": _data.signature?_data.signature:ipay88_signature,
                                "ResponseURL": this.paymentRedirectURL,
                                // "ResponseURL": 'http://azu-play.mygolf2u.com/payment_redirect.html',
                                // "BackendURL": 'http://azulet.mygolf2u.com/rest/payment/ipay88/backend',
                                // "BackendURL": 'http://devlet.mygolf2u.com/rest/payment/ipay88/backend',
                                "BackendURL": this.paymentBackendURL,
                                "PaymentURL": this.paymentPageURL,
                                // "https://payment.ipay88.co.id/epayment/entry.asp"
                                // _data.callback_url?_data.callback_url:this.paymentBackendURL,//'http://devlet.mygolf2u.com/rest/payment/ipay88/backend'
                            }
                        }



                        // let _merchantCode = paymentDetailsPage['MerchantCode'];
                        let _MerchantCode = paymentDetailsPage["MerchantCode"]
                        let _PaymentId = paymentDetailsPage["PaymentId"]
                        let _RefNo = _data.bill; //paymentDetailsPage["RefNo"]
                        let _Amount = paymentDetailsPage["Amount"]
                        let _Currency = paymentDetailsPage["Currency"]
                        let _ProdDesc = paymentDetailsPage["ProdDesc"]
                        let _UserName = paymentDetailsPage["UserName"]
                        let _UserEmail = paymentDetailsPage["UserEmail"]
                        let _UserContact = paymentDetailsPage["UserContact"]
                        let _Remark = paymentDetailsPage["Remark"]
                        let _SignatureType = paymentDetailsPage["SignatureType"]
                        let _Signature = paymentDetailsPage["Signature"]
                        let _ResponseURL = paymentDetailsPage["ResponseURL"]
                        let _BackendURL = paymentDetailsPage["BackendURL"]

                        let _params =
                            'MerchantCode=' + _MerchantCode +
                            '&PaymentId=' + _PaymentId +
                            '&RefNo=' + _RefNo +
                            '&Amount=' + _Amount +
                            '&Currency=' + _Currency +
                            '&ProdDesc=' + _ProdDesc +
                            '&UserName=' + _UserName +
                            '&UserEmail=' + _UserEmail +
                            '&UserContact=' + _UserContact +
                            '&Remark=' + _Remark +
                            '&SignatureType=' + _SignatureType +
                            '&Signature=' + _Signature +
                            '&ResponseURL=' + _ResponseURL +
                            '&BackendURL=' + _BackendURL;
                        // _ipayUrl = '/ipay88page'
                      //  console.debug("ipay88 test ", _params, _ipayUrl);

                        let map;


                        var form = document.createElement("form");
                        form.target = "_system";
                        form.method = "GET";
                        form.action = this._url;
                        form.style.display = "none";

                        for (var key in paymentDetailsPage) {
                            var input = document.createElement("input");
                            input.type = "hidden";
                            input.name = key;
                            input.value = paymentDetailsPage[key];
                            form.appendChild(input);
                        }

                        let _ipay88Header = `<html>
                        <head>
                        </head>`;

                        // http://app.mygolf2u.com/payment/goToPayment.html
                        let _ipay88Body = `<body >
<form id="loginForm" action="`+this.paymentInternalURL+`" method="get">
    <span style="font-size:5vw;">Redirecting to payment page ...</span><br>`;

    for (var key in paymentDetailsPage) {
        _ipay88Body += '<input type="hidden" name="' + key + '" value="' + paymentDetailsPage[key] + '">'
    };

    let _ipay88end = `<script type="text/javascript">
    setTimeout("document.getElementById('loginForm').submit()", 500);
    </script>
</body>

</html>`;

let _ipay88content = _ipay88Header + _ipay88Body + _ipay88end;

console.debug('calling ipay88 page', _ipay88content)


// let _ipay88ContentUrl = 'data:text/html;base64,' +this.mg2uUtil._btoa(encodeURIComponent(_ipay88content)); //btoa(_ipay88content);
let _ipay88ContentUrl = 'data:text/html;base64,' + this.mg2uUtil._btoa(_ipay88content);


                        let win;
                        if(this.platform.is('cordova')) {

                            this.openWithInAppBrowser(_ipay88ContentUrl,null,'getBill',data)
                        } else {

                            win = window.open("", '_system');
                            document.body.appendChild(form);
                            form.submit();
                            document.body.removeChild(form);

                        }

                        let winTick = setInterval(()=> {
                            if (win && win.closed) {
                                clearInterval(winTick);
                                this.getBill(data.bill, 'ipay88');
                              //  console.debug('window closed!');
                            }
                        }, 500);

                    }

              }, (error) => {
                  if (error) {
                    //  console.debug("Error : ", error.json())
                      let _error = error.json()
                      if (_error.status === "500" || _error.status === "404") {
                        //  console.debug("Server unreachable")
                          MessageDisplayUtil.showMessageToast('Server Unreachable',
                              this.platform, this.toastCtl, 3000, "bottom")
                      } else if (_error.status === 500 || _error.status === 404) {
                        //  console.debug("Server unreachable JSON")
                          MessageDisplayUtil.showMessageToast('Server Unreachable',
                              this.platform, this.toastCtl, 3000, "bottom")
                      }
                  }
              })

          }, async (error)=>{
              if(loader) (await loader).dismiss();
            //  console.debug("payment error : ",error)
              let _msg = error;
              if(_msg.toLowerCase().includes("mobile is invalid")) {
                  _msg = "Mobile phone is invalid. Please update profile and retry payment.";
              } else {
                  _msg = "Something wrong going with payment server. Please try again."
              }
              MessageDisplayUtil.showMessageToast(_msg,
                  this.platform, this.toastCtl, 3000, "bottom");
              // return false;
          })
  })
  setTimeout(async () => {
      (await loader).dismiss().then(() => {})
  }, 300000)
}


public openWithInAppBrowser(url: string, target ? : string,attribute?: string,data?:any) {
  let _target;
  if (target) _target = target;
  else _target = '_blank'
  if(this.platform.is('ios')) _target = '_blank';
  let _iab = this.iab.create(url, _target, this.options);

  if(this.platform.is('ios')) {
      _iab.on('loadstart').subscribe((event)=>{
          let loc = event.url.toLowerCase();
          if(loc.includes(this.paymentRedirectURL.toLowerCase()))
          {
                setTimeout(function () {
                  _iab.close();
                }, 5000);
          }
      })
  } else {
      _iab.on('loadstop').subscribe((event)=>{
          let loc = event.url.toLowerCase();
          if(loc.includes(this.paymentRedirectURL))
          {
                setTimeout(function () {
                  _iab.close();
                }, 5000);
          }
      })
  }
  // _iab.on('')
  // _iab.on('loadstop').subscribe(event => {
  //   //  console.debug("iab stop")
  //     MessageDisplayUtil.showMessageToast('IAB stop',
  //         this.platform, this.toastCtl, 10000, "bottom")
  //  });

  // MessageDisplayUtil.showMessageToast('IAB loading...',
  // this.platform, this.toastCtl,10000, "bottom");
   _iab.on('exit').subscribe(() => {
      // MessageDisplayUtil.showMessageToast('exit IAB - '+data.bill + '|'+this.selectPaymentMethod,
      // this.platform, this.toastCtl,10000, "bottom");
       if(attribute === 'getBill') {
          if(this.selectPaymentMethod.toLowerCase().includes('billplz')) {
              this.getBill(data.id, 'billplz');
          }
          else if(this.selectPaymentMethod.toLowerCase().includes('ipay88')) this.getBill(data.bill, 'ipay88');

       }
  }, (err) => {
      if(err) console.error(err);
  });
}
paymentMode: boolean = false;
paymentStatus: string = '';
public async getBill(billId ? : string, paymentGateway ? : string) {
  //  console.debug("calling getBill")
  let loader = this.loadingCtl.create({
      showBackdrop: false,
      cssClass    : "nobg",
      message     : "Getting bill info...",
      duration    : 10000
  });
  (await loader).present().then(() => {
    this.paymentService.getBill(billId, paymentGateway)
        .subscribe(async (data: any) => {
          //  console.debug("get local billplz bill state", data)
          //  console.debug("local billplz : ", data.paid, data.paid?'paid':'not paid')
            if ((data?.status && data?.paid === 'true' && data?.status.toLowerCase() === 'p') || (data?.state && data?.state.toLowerCase() === 'paid')
            && paymentGateway === 'billplz') {
                //   this.toggleRegister = true;
                // this.goPayMembership(true);
            this.paymentMode = false;
                this.paymentStatus = 'Paid';

            this.showMessage('Payment successful', 'Thank you for the payment.<br>Receipt will be sent to you via email.')
            .then((result: any)=>{
              // this.goPayMembership(true);
              if(result) {
                this.modalCtl.dismiss({
                  needRefresh: true
                });
              } else {
                // this.modalCtl.dismiss({
                //   needRefresh: true
                // });
              }
            });
                // let alert = await this.alertCtl.create({
                //   subHeader: 'Payment successful',
                //   message: 'Thank you for the payment.<br>Receipt will be sent to you via email.', //'Selected date is ' + '<b>' + _date + '</b>',

                //   buttons: [{
                //     text: 'Close',
                //     handler: () => {

                //       this.modalCtl.dismiss({
                //         needRefresh: true
                //       });
                //     }
                //   }],
                //   backdropDismiss: false,
                // });
                // (await loader).dismiss().then(()=>{
                //   alert.present();
                // })
            } else if ((data?.status && data?.status.toLowerCase() === 'p') ||  (data?.state && data?.state.toLowerCase() === '1')
            && paymentGateway === 'ipay88') {

                this.showMessage('Payment successful', 'Thank you for the payment.<br>Receipt will be sent to you via email.')
                .then((result: any)=>{
                  // this.goPayMembership(true);
                  if(result) {
                    this.modalCtl.dismiss({
                      needRefresh: true
                    });
                  } else {
                    // if(this.enablePaymentTimer) {
                    //     this.paymentFailed = true;
                    //     this.paymentDateTime = moment();
                    // }
                  }
                });
                // let alert = await this.alertCtl.create({
                //   subHeader: 'Payment successful',
                //   message: 'Thank you for the payment.<br>Receipt will be sent to you via email.', //'Selected date is ' + '<b>' + _date + '</b>',

                //   buttons: [{
                //     text: 'Close',
                //     handler: () => {
                //       this.modalCtl.dismiss({
                //         needRefresh: true
                //       });

                //     }
                //   }],
                //   backdropDismiss: false,
                // });
                // (await loader).dismiss().then(()=>{
                //   alert.present();
                // })
            } else if ((data?.state && data?.state.toLowerCase() === 'due') || (data?.status && data?.status.toLowerCase() === 'd')) {

            this.showMessage('Payment not successful', 'Something went wrong with payment. Please refresh and try again in few minutes.', true)
            .then((result: any)=>{
              if(result) {

              } else {
                // if(this.enablePaymentTimer) {
                //     this.paymentFailed = true;
                //     this.paymentDateTime = moment();
                // }
              }
            });
                // let alert = await this.alertCtl.create({
                //   subHeader: 'Payment not successful',
                //   cssClass: 'booking-error',
                //   // subTitle: 'Selected date is '+ _date,
                //   message: 'Something went wrong with payment. Please refresh and try again in few minutes.', //'Selected date is ' + '<b>' + _date + '</b>',

                //   // buttons: ['Close']
                //   buttons: [{
                //     text: 'Close',
                //     handler: () => {
                //       //! this.modalCtl.dismiss({
                //       //!     needRefresh: true
                //       //! })
                //       //   this.recalculateBookingPricing();
                //     }
                //   }],
                //   backdropDismiss: false,
                // });
                // (await loader).dismiss().then(()=>{
                //   alert.present();
                // })
                if(this.enablePaymentTimer) {
                    this.paymentFailed = true;
                    this.paymentDateTime = moment();
                }
            }
            else {
                if(0) {
                  // this.enablePaymentTimer
                  //   this.paymentFailed = true;
                  //   this.paymentDateTime = moment();
                }
                this.modalCtl.dismiss({
                    needRefresh: true
                })
              //   this.onCancelAssignment()
            }
            if(loader) (await loader).dismiss();
        }, async (error)=>{
            this.paymentStatus = 'Pending';

            if(loader) (await loader).dismiss();
            this.showMessage('Ooops', 'Something went wrong with payment. Please refresh and try again in few minutes.', true)
            .then((result: any)=>{
              if(result) {

              } else {
                if (this.enablePaymentTimer) {
                  this.paymentFailed = true;
                  this.paymentDateTime = moment();
                }
              }
            });
            // let alert = await this.alertCtl.create({
            //   subHeader: 'Ooops',
            //   cssClass: 'booking-error',
            //   // subTitle: 'Selected date is '+ _date,
            //   message: 'Something went wrong with payment. Please refresh and try again in few minutes.', //'Selected date is ' + '<b>' + _date + '</b>',

            //   // buttons: ['Close']
            //   buttons: [{
            //     text: 'Close',
            //     handler: () => {
            //       if (this.enablePaymentTimer) {
            //         this.paymentFailed = true;
            //         this.paymentDateTime = moment();
            //       }
            //       //! this.modalCtl.dismiss({
            //       //!     needRefresh: true
            //       //! })
            //       //   this.recalculateBookingPricing();
            //     }
            //   }],
            //   backdropDismiss: false,
            // });
            // (await loader).dismiss().then(()=>{
            //   alert.present();
            // })
        })
      });
      }

      showMessage(title: string, content: string, isError?: boolean) {
        return new Promise(async (resolve, reject)=>{

          let _message = {
            title: title,
            content: content
          }
        const modal = await this.modalCtl.create({
          mode: 'ios',
          component: CommonPullupMenuComponent,
          cssClass: 'self-adjustable-modal',
          componentProps: {
              app: null,
              message: _message,
              mode: 'messageSuccess',
              // headerTitle: title,
          }
        })
        await modal.present().then(() => {
            const height = this.platform.height() - 250;
            document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        });
        modal.onDidDismiss().then((data: any) => {
          console.debug("pullup dismiss", data)
          if(data) {
            resolve(true)
            // if(data?.data?.id) {
            //   // this._changeScorer(player, data?.data?.data);
            // }
          } else resolve(false)
          // if(data)

        })
        })
      }
}
